var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-chip',{staticClass:"white--text",attrs:{"color":_vm.value
      ? _vm.value.toLowerCase() == 'active'
        ? 'warning'
        : _vm.value.toLowerCase() == 'draft'
        ? 'grey'
        : _vm.value.toLowerCase() == 'inactive'
        ? 'red'
        : 'green'
      : 'grey',"disabled":""}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fac63e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/generalixwarroom/GameSetting/CampaignStatus.vue
// module id = null
// module chunks = 